import classNames from 'classnames/bind';
import { isOnOff } from '../../../constants/common';
import { LANGUAGE } from '../../../constants/language';
import { CAREER_DEFINITION, RECRUITMENT_TYPE_DEFINITION } from '../../../constants/position/common';
import { SOLUTION } from '../../../constants/solution/solution.constant';
import useMultiLanguage from '../../../hook/useMultiLanguage';
import {
  IGetJDViewSettingResponse,
  IGetJobdaJDViewSettingResponse,
  IGetJobflexJDViewSettingResponse,
} from '../../../interface/position/getJDViewSetting';
import { IJD } from '../../../interface/recruit/IJD';
import { formatDateForEnglish, formatDateForKorea } from '../../../util/dayUtil';
import { SOLUTION_TYPE } from '../../../util/solution';
import style from './JDProcess.module.scss';
import JDProcessItem from './JDProcessItem';
const cx = classNames.bind(style);

interface IProps {
  data: IJD;
  viewSettingData: IGetJDViewSettingResponse;
}

const JDProcessItems = ({ data, viewSettingData }: IProps) => {
  const { multiLanguageText, languageType } = useMultiLanguage();
  const { jobGroup, careerType, address, detailAddress, endDateTime, recruitmentType, classificationCode } = data;

  if (SOLUTION_TYPE === SOLUTION.JOBDA) {
    const jdViewSettingJobda = viewSettingData as IGetJobdaJDViewSettingResponse;
    const { jobGroupToggle, recruitmentTypeToggle, workingAreaToggle, endDateTimeToggle } = jdViewSettingJobda ?? {};

    return (
      <ul className={cx('info')}>
        <JDProcessItem show={isOnOff(jobGroupToggle)} label={'직군'} text={jobGroup} />
        <JDProcessItem
          show={isOnOff(recruitmentTypeToggle)}
          label={'채용 형태'}
          text={careerType && CAREER_DEFINITION[careerType][LANGUAGE.KOR]}
        />
        <JDProcessItem show={isOnOff(workingAreaToggle)} label={'근무지'} text={`${address} ${detailAddress ?? ''}`} />
        <JDProcessItem
          show={isOnOff(endDateTimeToggle)}
          label={multiLanguageText('마감일', 'Deadline')}
          text={multiLanguageText(
            formatDateForKorea(endDateTime, true, '영입 종료 시'),
            formatDateForEnglish(endDateTime, true, 'Open Until Filled')
          )}
        />
      </ul>
    );
  }

  if (SOLUTION_TYPE === SOLUTION.JOBFLEX) {
    const jdViewSettingJobflex = viewSettingData as IGetJobflexJDViewSettingResponse;
    const { classificationCodeToggle, recruitmentTypeToggle, careerTypeToggle, endDateTimeToggle } =
      jdViewSettingJobflex ?? {};

    return (
      <ul className={cx('info')}>
        <JDProcessItem
          show={isOnOff(classificationCodeToggle) && languageType === LANGUAGE.KOR}
          label={'채용 구분'}
          text={recruitmentType === 'PRIVATE' ? '-' : classificationCode ?? ''}
        />
        <JDProcessItem
          show={isOnOff(recruitmentTypeToggle)}
          label={multiLanguageText('채용 형태', 'Job Type')}
          text={recruitmentType ? RECRUITMENT_TYPE_DEFINITION[recruitmentType][languageType] : ''}
        />
        <JDProcessItem
          show={isOnOff(careerTypeToggle)}
          label={multiLanguageText('신입/경력', 'Experience Level')}
          text={careerType && CAREER_DEFINITION[careerType][languageType]}
        />
        <JDProcessItem
          show={isOnOff(endDateTimeToggle)}
          label={multiLanguageText('마감일', 'Deadline')}
          text={multiLanguageText(
            formatDateForKorea(endDateTime, true, '영입 종료 시'),
            formatDateForEnglish(endDateTime, true, 'Open Until Filled')
          )}
        />
      </ul>
    );
  }

  return null;
};

export default JDProcessItems;
